import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SearchEmployeeDialogService } from 'src/app/services/Non-Master/SearchEmployeeDialog.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { tEmployeeModel, tEmployeeWithTypeModel } from 'src/app/models/tEmployeeModel';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { isNullOrUndefined } from 'util';
import { tVendorModel } from 'src/app/models/tVendorModel';
import {SearchPODialogListProps, tPurchaseOrderModel} from 'src/app/models/tPurchaseOrderModel';
import { tVendorService } from 'src/app/services/tVendor.service';
import { tPurchaseOrderService } from 'src/app/services/tPurchaseOrder.service';
import { UnitMediPurchaseService } from 'src/app/services/Unit/UnitMediPurchase.service';
import { UnitMediStockService } from 'src/app/services/Unit/UnitMediStock.service';
import { UnitMediPurchaseModel } from 'src/app/models/UnitMediPurchaseModel';
import { UnitMediStockModel } from 'src/app/models/UnitMediStockModel';
import { UnitItemModel } from 'src/app/models/UnitItemModel';
import { UnitItemService } from 'src/app/services/Unit/UnitItem.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-search-po-dialog',
  templateUrl: './search-po-dialog.component.html',
  styleUrls: ['./search-po-dialog.component.css']
})
export class SearchPoDialogComponent implements OnInit {

  TAG = 'SearchVendorDialogComponent';

  editForm: FormGroup;

  @Input() actionCase: number;
  @Input() vendorCode: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<SearchPODialogListProps>;
  checkLoadingDataSource: any;
  dataList: SearchPODialogListProps[];
  grnPurchUnit_med_selection : UnitMediPurchaseModel[];
  grnPurchUnit_item_selection : UnitItemModel[];


  displayedColumns: string[] = [
    // 'action_button_title',
    'action_select',
    'poDate',
    'poNumber',

    'itemID',
    'itemDesc',
    'purQty',
    'purUnit',
    //'unitPrice',
  //  'Warehouse'
    'itemBalance'
  ];


  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private tVendorService: tVendorService,
    private tPurchaseOrderService:tPurchaseOrderService,
    private unitMediPurchaseService: UnitMediPurchaseService,
    private unitMediStockService: UnitMediStockService,
    private unitItemService: UnitItemService,
    public translate: TranslateService,
  ) {    
    let currentLanguage = localStorage.getItem('currentLanguage');
    translate.use(currentLanguage); 
    }

  generalFilter = new FormControl();
  filteredValues = {
    mediCode: '', mediName: '', mediNameEng: '', mediBarCode: ''
  };

  //loading spinner
  isLoading = true;


  ngOnInit() {
    this.getAllData();
    
    this.unitMediPurchaseService.getActiveDatas().subscribe(data => {
      this.grnPurchUnit_med_selection = data;
    });


  }

  getAllData(): void {
    this.log.i(this.TAG, ' getAllProducts');
    
    this.tPurchaseOrderService
      .getVendorData(this.vendorCode)
      .subscribe((data) => {

        this.tPurchaseOrderService
          .getPOItemsBalance(this.vendorCode)
          .subscribe((itemsBalance) => {
            data.forEach((x) => {
              let a = itemsBalance.find((c) => x.poItemID === c.grnItemID && x.poNumber == c.grnPoNumber);
              x.itemBalance = a ? (x.poPurchQty - a.usedQty) : x.poPurchQty;
            });
            this.dataList = data;

            this.dataList.forEach((x) => (x.selected = "N"));

            this.dataSource = new MatTableDataSource<SearchPODialogListProps>(
              data
            );
            this.dataSource.paginator = this.paginator;

            //loading spinner
            this.isLoading = false;
            this.checkLoadingDataSource = data;
            //table sort
            this.dataSource.sort = this.sort;

            this.generalFilter.valueChanges.subscribe((generalFilterValue) => {
              this.filteredValues["vendorName"] = generalFilterValue;
              this.filteredValues["vendorNameEng"] = generalFilterValue;
              this.dataSource.filter = JSON.stringify(this.filteredValues);
            });
          });
      });
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tVendorModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return (searchString.vendorName.toLowerCase() == '' || 
      (data.vendorName != null 
        && data.vendorName.toString().trim().toLowerCase().indexOf(searchString.vendorName.toLowerCase()) !== -1))
      || 
      (searchString.vendorNameEng.toLowerCase() == '' || 
      (data.vendorNameEng != null 
        && data.vendorNameEng.toString().trim().toLowerCase().indexOf(searchString.vendorNameEng.toLowerCase()) !== -1))
        ;

    }

    return myFilterPredicate;
  }


  selectedRecord() {
    var returnData=this.dataList.filter(p=>p.selected=="Y");

    this.activeModal.close(returnData);
  }
  
  displayPurchUnit(uid: number) {

    if (isNullOrUndefined(uid) || !this.grnPurchUnit_med_selection) {
      return;
    }


    return this.grnPurchUnit_med_selection.find(p => p.mediPurchaseUnitID === uid).purchaseUnitName;



  }

  changeSelect(value,element:tPurchaseOrderModel){
    this.log.i("Test value:",value);
    if(value==true){
      element.selected="Y";
      this.log.i("selected value:",element.selected);
    }else{
      element.selected="N";
      this.log.i("selected value:",element.selected);
    }
  }
}
